"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIsolatedPackageLogger = createIsolatedPackageLogger;
exports.createIsolatedPackageLoggerWithFlags = createIsolatedPackageLoggerWithFlags;
var _customLoggers = require("./customLoggers");
var _logger = require("./logger");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * This can be used in packages to have package level logging (or turn off logging for a package)
 * @param logger The logger to use initially.
 * @returns a copy of the logger passed in and a 'setLogger' method for updating it.
 */
function createIsolatedPackageLogger(logger) {
  let currentLogger = (0, _logger.cloneLogger)(logger || (0, _customLoggers.createBasicConsoleLogger)());
  return {
    setLogger: logger => currentLogger = (0, _logger.cloneLogger)(logger),
    getLogger: () => currentLogger,
    debug: msg => currentLogger.debug(msg),
    info: msg => currentLogger.info(msg),
    notice: msg => currentLogger.notice(msg),
    warn: msg => currentLogger.warn(msg),
    error: msg => currentLogger.error(msg),
    critical: msg => currentLogger.critical(msg)
  };
}

/**
 * This can be used in packages to have package level logging (or turn off logging for a package)
 * @param logger The logger to use initially.
 * @returns a copy of the logger passed in and a 'setLogger' method for updating it.
 */
function createIsolatedPackageLoggerWithFlags(flagType, activeFlags, allFlag, logger) {
  const underlyingLogger = (0, _logger.cloneLogger)(logger || (0, _customLoggers.createBasicConsoleLogger)());
  const props = {
    flagType,
    underlyingLogger,
    activeFlags,
    allFlag
  };
  const packageLogger = _objectSpread({
    setLogger: logger => {
      props.underlyingLogger = (0, _logger.cloneLogger)(logger);
    },
    getLogger: () => underlyingLogger,
    setFlags: flags => {
      props.activeFlags = flags;
    },
    getFlags: () => props.activeFlags
  }, (0, _customLoggers.createLoggerWithFlags)(props));
  return packageLogger;
}